var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-card", staticStyle: { width: "auto" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(_vm._s(_vm.$t("title"))),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            }),
          ]),
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "spinner" },
                [
                  _vm.isLoading
                    ? _c("Spinner", { staticClass: "spinner2" })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c("ValidationObserver", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ handleSubmit }) {
                  return [
                    _c(
                      "section",
                      { staticClass: "modal-card-body" },
                      [
                        _c(
                          "b-field",
                          [
                            _c("validationInput", {
                              attrs: {
                                rules: "required|email",
                                "icon-pack": "fas",
                                icon: "envelope",
                                type: "email",
                                label: "Email",
                              },
                              model: {
                                value: _vm.values.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.values, "email", $$v)
                                },
                                expression: "values.email",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          [
                            _c("validationInput", {
                              attrs: {
                                rules: "required",
                                "icon-pack": "fas",
                                icon: "user",
                                label: _vm.$t("name"),
                              },
                              model: {
                                value: _vm.values.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.values, "name", $$v)
                                },
                                expression: "values.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          [
                            _c("validationInput", {
                              attrs: {
                                "icon-pack": "fas",
                                icon: "image-portrait",
                                rules: "required|cnpj_id",
                                label: _vm.$t("identification"),
                              },
                              model: {
                                value: _vm.values.idNumber,
                                callback: function ($$v) {
                                  _vm.$set(_vm.values, "idNumber", $$v)
                                },
                                expression: "values.idNumber",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-field",
                          [
                            _c("validationInput", {
                              attrs: {
                                icon: "fa-solid fa-phone",
                                rules: "phoneBr",
                                "icon-right": _vm.iconRight,
                                label: _vm.$t("phone"),
                              },
                              model: {
                                value: _vm.values.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.values, "phone", $$v)
                                },
                                expression: "values.phone",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "footer",
                      { staticClass: "modal-card-foot" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "button is-success",
                            on: {
                              click: function ($event) {
                                return handleSubmit(_vm.submit)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon is-small" }, [
                              _c("i", { staticClass: "fas fa-check" }),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.$t("create")))]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: { click: _vm.resetForm },
                          },
                          [
                            _c("span", { staticClass: "icon is-small" }, [
                              _c("i", { staticClass: "fas fa-redo" }),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.$t("reset")))]),
                          ]
                        ),
                        _c("b-button", {
                          attrs: { label: _vm.$t("close") },
                          on: {
                            click: function ($event) {
                              return _vm.close()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }